import {
  APP_KEY,
  APP_PATH
} from 'modules/app/constants'
import setReduxAction from 'modules/redux/actions/set'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'
import getRenderCountAppSelect from 'modules/app/selectors/get-render-count/index.js'

export default function updateRenderCountAppAction () {
  return (dispatch, getState) => {
    const renderCount = getRenderCountAppSelect(getState())
    const value = renderCount + 1

    dispatch(
      setReduxAction({
        type: getActionStrReduxUtil(
          REDUX_ACTION_PREFIX.UPDATE,
          APP_KEY.RENDER_COUNT,
          value
        ),
        payload: {
          path: APP_PATH.RENDER_COUNT,
          value
        }
      })
    )
  }
}
